import TabSection from './TabSection';

export default TabSection;
